type Listener = () => void

class MockStore {
  private listeners: Set<Listener> = new Set()

  private data = {
    tasks: [
      {
        id: 'TSK-001',
        title: 'Klarifikasi deepfake audio Presiden di TikTok',
        pic: 'Komdigi - Ditjen Aptika',
        deadline: '4 jam',
        severity: 'KRITIS',
        status: 'PROSES',
      },
      {
        id: 'TSK-002',
        title: 'Rilis data resmi distribusi bansos pangan',
        pic: 'Kemensos - Biro Humas',
        deadline: '8 jam',
        severity: 'TINGGI',
        status: 'BELUM',
      },
      {
        id: 'TSK-003',
        title: 'Review pengamanan digital kunjungan Papua',
        pic: 'Paspampres',
        deadline: '12 jam',
        severity: 'TINGGI',
        status: 'PROSES',
      },
      {
        id: 'TSK-004',
        title: 'Takedown akun impersonation @presidenri_official',
        pic: 'Komdigi & Polri Siber',
        deadline: '24 jam',
        severity: 'SEDANG',
        status: 'REVIEW',
      },
      {
        id: 'TSK-005',
        title: 'Verifikasi paket bukti hoaks bansos',
        pic: 'Tim Hukum KSP',
        deadline: '6 jam',
        severity: 'TINGGI',
        status: 'PROSES',
      },
      {
        id: 'TSK-006',
        title: 'Statement empatik kebijakan pangan',
        pic: 'Juru Bicara Presiden',
        deadline: '3 jam',
        severity: 'KRITIS',
        status: 'BELUM',
      },
    ],
    notifications: [
      {
        id: 1,
        sev: 'KRITIS',
        title: 'Deepfake audio Presiden viral',
        body: '45 video teridentifikasi di TikTok dengan watermark palsu.',
        time: '10 menit lalu',
        category: 'Threat Intel',
        read: false,
      },
      {
        id: 2,
        sev: 'TINGGI',
        title: 'Operasi tagar #TolakKebijakanX',
        body: '1.247 akun bot terdeteksi terkoordinasi sejak 02:00 WIB.',
        time: '45 menit lalu',
        category: 'Bot Detection',
        read: false,
      },
      {
        id: 3,
        sev: 'TINGGI',
        title: 'Ancaman kunjungan Papua',
        body: 'Komentar spesifik menyebut lokasi & tanggal kunjungan presiden.',
        time: '1 jam lalu',
        category: 'Visit Intel',
        read: false,
      },
      {
        id: 4,
        sev: 'SEDANG',
        title: 'Sentimen pangan turun 12%',
        body: 'Pasca-pidato kebijakan, didominasi sentimen negatif Jawa Tengah.',
        time: '3 jam lalu',
        category: 'Sentiment',
        read: true,
      },
      {
        id: 5,
        sev: 'SEDANG',
        title: 'Akun impersonation Presiden',
        body: '@presidenri_official, 5.000 followers, phishing terdeteksi.',
        time: '4 jam lalu',
        category: 'Threat Intel',
        read: true,
      },
    ],
    alerts: [
      {
        id: 1,
        severity: 'critical',
        label: 'Lonjakan narasi separatis terdeteksi di Papua',
        time: '14:32 WIB',
      },
      {
        id: 2,
        severity: 'warning',
        label: 'Aktivasi bot farm di Jawa Barat (1.247 akun)',
        time: '14:30 WIB',
      },
      {
        id: 3,
        severity: 'critical',
        label: 'Deepfake audio Presiden terdeteksi di TikTok',
        time: '14:28 WIB',
      },
      {
        id: 4,
        severity: 'info',
        label: 'Sentimen positif naik 4% pasca-pidato ekonomi',
        time: '14:25 WIB',
      },
      {
        id: 5,
        severity: 'warning',
        label: 'Foreign influence terdeteksi dari klaster server luar negeri',
        time: '14:20 WIB',
      },
    ],
  }

  subscribe(listener: Listener) {
    this.listeners.add(listener)
    return () => this.listeners.delete(listener)
  }

  private notify() {
    this.listeners.forEach((l) => l())
  }

  private async delay(ms = 400) {
    return new Promise((resolve) => setTimeout(resolve, ms))
  }

  // --- TASKS ---
  async getTasks() {
    await this.delay(200)
    return [...this.data.tasks]
  }

  async addTask(task: any) {
    await this.delay()
    const newTask = {
      ...task,
      id: `TSK-00${this.data.tasks.length + 1}`,
      status: 'BELUM',
    }
    this.data.tasks = [newTask, ...this.data.tasks]
    this.notify()
    return newTask
  }

  async updateTaskStatus(id: string, status: string) {
    await this.delay(300)
    this.data.tasks = this.data.tasks.map((t) =>
      t.id === id ? { ...t, status } : t,
    )
    this.notify()
  }

  // --- NOTIFICATIONS ---
  async getNotifications() {
    await this.delay(100)
    return [...this.data.notifications]
  }

  async markNotificationRead(id: number) {
    await this.delay(100)
    this.data.notifications = this.data.notifications.map((n) =>
      n.id === id ? { ...n, read: true } : n,
    )
    this.notify()
  }

  async markAllNotificationsRead() {
    await this.delay(300)
    this.data.notifications = this.data.notifications.map((n) => ({
      ...n,
      read: true,
    }))
    this.notify()
  }

  // --- ALERTS ---
  async getAlerts() {
    await this.delay(100)
    return [...this.data.alerts]
  }
}

export const mockApi = new MockStore()
